import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from '../elements/button';
import { Upload, Download } from '../../assets/icons';
import { uploadMultipleFiles } from '../../services/uploadService';

export const LabReport = ({ caseId, onSubmit }) => {
    const [results, setResults] = useState({
        findings: '',
        recommendations: '',
        attachments: []
    });

    const handleFileUpload = async (e) => {
        const files = Array.from(e.target.files);
        const urls = await uploadMultipleFiles(files, `lab-reports/${caseId}`);
        setResults(prev => ({
            ...prev,
            attachments: [...prev.attachments, ...urls]
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        await onSubmit(results);
        setResults({
            findings: '',
            recommendations: '',
            attachments: []
        });
    };

    return (
        <div className="lab-report-form">
            <h3>Lab Report</h3>
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label>Findings</label>
                    <textarea
                        value={results.findings}
                        onChange={(e) => setResults({
                            ...results,
                            findings: e.target.value
                        })}
                        required
                    />
                </div>

                <div className="form-group">
                    <label>Recommendations</label>
                    <textarea
                        value={results.recommendations}
                        onChange={(e) => setResults({
                            ...results,
                            recommendations: e.target.value
                        })}
                        required
                    />
                </div>

                <div className="file-upload">
                    <input
                        type="file"
                        multiple
                        onChange={handleFileUpload}
                        accept=".pdf,.jpg,.png,.doc,.docx"
                    />
                    <Button
                        icon={<img src={Upload} alt="" />}
                        text="Upload Supporting Documents"
                        variant="outline"
                    />
                </div>

                {results.attachments.length > 0 && (
                    <div className="attachments-list">
                        {results.attachments.map((url, index) => (
                            <div key={index} className="attachment-item">
                                <span>{url.split('/').pop()}</span>
                                <Button
                                    icon={<img src={Download} alt="" />}
                                    variant="text"
                                    onClick={() => window.open(url)}
                                />
                            </div>
                        ))}
                    </div>
                )}

                <Button
                    text="Submit Lab Report"
                    type="submit"
                    variant="primary"
                />
            </form>
        </div>

    
    );
};

LabReport.propTypes = {
    caseId: PropTypes.string.isRequired,
    onSubmit: PropTypes.func.isRequired
}; 

export default LabReport;